<template>
    <v-card>
        <v-card-title>
            Personal
            <v-spacer></v-spacer>
            <v-checkbox
             v-model="onlyActive"
             label="Afisare doar personal activ"
            />
            <v-btn
                color="primary"
                dark
                class="ml-2"
                @click="addNewItem"
            >
                Adaugare
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" lg="3" class="my-2" v-for="(employee, index) in employees" :key="index">
                    <v-card :to="{ name: 'employees-edit', params: { id: employee.id } }" elevation="5" class="mx-auto">
                        <v-img class="white--text align-end" height="350px" :src="employee.profile_image">
                            <v-card-title>
                                <v-badge
                                    v-if="!_.isNil(employee.data.demission_date)"
                                    color="red"
                                    :content="$options.filters.date(new Date(employee.data.demission_date))"
                                >
                                    {{ employee.name }}
                                </v-badge>
                                <template v-else>
                                    {{ employee.name }}
                                </template>
                            </v-card-title>
                        </v-img>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        data: () => ({
            onlyActive: true,
            items: [],
            meta: {
                pagination: {
                    count: 0,
                    current_page: 0,
                    per_page: 0,
                    total: 0,
                    total_pages: 0
                }
            }
        }),

        computed: {
            employees() {
                if(!this.onlyActive) return this.items
                return this.items.filter(item => this._.isNil(item?.data?.demission_date))
            }
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                let { data, meta } = await this.$db.Employee
                    .page(1)
                    .limit(500)
                    .get()
                this.items = data.sort(function(a, b) {
                    var nameA = a.name.toUpperCase();
                    var nameB = b.name.toUpperCase();
                    return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
                });
                this.meta = meta
            },
            addNewItem: function() {
                this.$router.push({ name: 'employees-create' })
            },
        },
    };
</script>
